import { type FC } from 'react';
import { Alert, Flex, Stack, Switch, Text } from '@mantine/core';
import { useUnit } from 'effector-react';
import { IconInfoCircle } from '@tabler/icons-react';
import {
    $isPayoutMarketRequired,
    $payoutTraderInfo,
    $payoutWorkingStatus,
    getMePayoutTraderFx,
    PayoutWorkingStatus,
    useUpdatePayoutWorkingStatus,
} from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { OrdersList, ReceiptInstructions } from './components';
import { filters, paginationModel } from './model';

export const Processing: FC = () => {
    const { trader, isMarketRequired, workingStatus, isWorkingStatusPending } = useUnit({
        trader: $payoutTraderInfo,
        isMarketRequired: $isPayoutMarketRequired,
        workingStatus: $payoutWorkingStatus,
        isWorkingStatusPending: getMePayoutTraderFx.pending,
    });

    const { mutate, isPending } = useUpdatePayoutWorkingStatus();

    const isWorkStarted = workingStatus === PayoutWorkingStatus.WORKING_STATUS_IN_WORK;
    const receiptEmail = trader?.checkEmail?.value;

    const onUpdateWorkingStatus = () => {
        if (workingStatus === PayoutWorkingStatus.WORKING_STATUS_IN_WORK) {
            mutate({
                workingStatus: PayoutWorkingStatus.WORKING_STATUS_READY,
            });

            return;
        }

        mutate({
            workingStatus: PayoutWorkingStatus.WORKING_STATUS_IN_WORK,
        });
    };

    return (
        <Stack gap='md'>
            {receiptEmail && <ReceiptInstructions />}

            {isMarketRequired && (
                <Alert
                    variant='light'
                    color='yellow'
                    title='Внимание!'
                    icon={<IconInfoCircle />}
                >
                    Для подтверждения выплаты понадобится привязка к ордеру на бирже. Подтвердить ордер можно будет
                    только в расширении.
                </Alert>
            )}

            <Flex
                direction={{ base: 'column', sm: 'row' }}
                justify='space-between'
                align={{ base: 'flex-start', sm: 'center' }}
                gap='md'
            >
                {receiptEmail && (
                    <KeyValuePair
                        label='Email для чеков'
                        value={<Text>{receiptEmail}</Text>}
                        copyValue={receiptEmail}
                        w={{ base: '100%', sm: 300 }}
                    />
                )}

                <Switch
                    fw={500}
                    color='green'
                    label='Трафик'
                    onChange={onUpdateWorkingStatus}
                    checked={isWorkStarted}
                    disabled={isPending || isWorkingStatusPending}
                />
            </Flex>

            <OrdersList
                filters={filters}
                paginationModel={paginationModel}
            />
        </Stack>
    );
};
